import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {getText, renderMarkdown} from 'helpers/text-helper';
import {gameUiTexts} from 'data/ui-texts';
import Button from 'components/ui/button/button';
import './popup-confirm-cookies.scss';

const PopupConfirmCookies = ({languageId, toggleAcceptCookies, setCookiePopupType}) => {

	/* Hide / show more info */
	const [showMoreInfo, setShowMoreInfo] = useState(false);

	return (
		<div className="PopupConfirmCookies">
			<div className="PopupConfirmCookies-content">
				<div className="PopupConfirmCookies-closeBtn" onClick={() => {setCookiePopupType(null);}}/>
				<div className="PopupConfirmCookies-text">
					{renderMarkdown(getText(gameUiTexts.cookieText1, languageId))}
					{showMoreInfo && renderMarkdown(getText(gameUiTexts.cookieText2, languageId))}
				</div>
				<div
					className="PopupConfirmCookies-textBtn"
					onClick={() => {setShowMoreInfo(!showMoreInfo);}}
				>
					<span>
						{showMoreInfo ?
							getText(gameUiTexts.cookieSeeLess, languageId) :
							getText(gameUiTexts.cookieSeeMore, languageId)}
					</span>
				</div>
				<div className="PopupConfirmCookies-buttons">
					<div className="PopupConfirmCookies-button yes">
						<Button
							text={getText(gameUiTexts.yes, languageId)}
							classes={['blue', 'fullHeight']}
							onClick={() => {toggleAcceptCookies(true);}}
						/>
					</div>
					<div className="PopupConfirmCookies-button no">
						<Button
							text={getText(gameUiTexts.no, languageId)}
							classes={['yellow', 'fullHeight']}
							onClick={() => {toggleAcceptCookies(false);}}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

PopupConfirmCookies.propTypes = {
	languageId: PropTypes.string.isRequired,
	toggleAcceptCookies: PropTypes.func.isRequired,
	setCookiePopupType: PropTypes.func.isRequired,
};

export default PopupConfirmCookies;
